/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { css } from "@emotion/react";
import { colors } from "../../colors";

const labelContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const subtextStyle = css`
  margin-top: 8px;
  align-self: start;
`;

type Props = {
  label?: string;
  children: React.ReactNode;
  errorMessage?: string;
  helperText?: string;
  labelIcon?: React.ReactNode;
  width?: string;
};

export const FieldSkeleton = ({
  label,
  children,
  errorMessage,
  helperText,
  labelIcon,
  width,
}: Props) => {
  const outerWrapperStyle = css`
    display: flex;
    flex-direction: column;
    width: ${width ? width : "100%"};
    ${width ? `max-width: ${width}; min-width: ${width};` : ""}
  `;

  return (
    <div css={outerWrapperStyle}>
      {label && (
        <div css={labelContainerStyle}>
          <StyledText
            color={colors.textPrimary}
            className="mb-0 bodySubtextSemibold"
          >
            {label}
          </StyledText>
          {labelIcon && labelIcon}
        </div>
      )}
      {children}
      {errorMessage && (
        <StyledText
          css={subtextStyle}
          className="mb-0 bodySubtextRegular"
          color={colors.errorDark}
        >
          {errorMessage}
        </StyledText>
      )}
      {!errorMessage && helperText && (
        <StyledText
          css={subtextStyle}
          className="mb-0 bodySubtextRegular"
          color={colors.textSecondary}
        >
          {helperText}
        </StyledText>
      )}
    </div>
  );
};
